import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ContactInformation } from '../../../../models/masters/contact-information.interface';
import { ContactActions, ContactService } from '../../../../services/masters/contact.service';
import { ContactInformationComponent } from '../contact-info/contact-information.component';
import { DynamicForm } from '../../../../models/dynamic-form';

@Component({
  selector: 'app-contact-dialog',
  standalone: true,
  imports: [ContactInformationComponent],
  templateUrl: './contact-dialog.component.html',
  styleUrl: './contact-dialog.component.scss'
})
export class ContactDialogComponent {

  @Input() contactInformation: ContactInformation | null = null;
  @Input() contactFormConfig!: DynamicForm;
  @Input() action!: ContactActions;

  @Output() onValueChange = new EventEmitter<{controlName: string, result: any}>();

  @ViewChild(ContactInformationComponent) contactInfoComponent!: ContactInformationComponent;

  constructor(private contactService: ContactService) {
  }

  submit() {
    this.contactInfoComponent.contactForm.markAllAsTouched();
    if (this.contactInfoComponent.contactForm.valid) {
      const formValues = this.contactService.createContactFromForm(this.contactInfoComponent.contactForm);
      this.closeModal(formValues);
    }
  }

  closeModal!: (params?: any) => void;

  close(params?: any) {
    if (this.closeModal) {
      this.closeModal(params);
    }
  }

}
